export default {
  logoAlt: 'Logotyp',
  personalPlanTitle: 'Din personliga Livsstilsplan - bara för dig!',
  bwellDescription: 'Bwell hjälper dig att bestämma hur du vill ha ditt fysiska, mentala och sociala liv för att må bra, både på jobbet och i livet.',
  privacyNotice: 'OBS! Det är bara du som kan se dina resultat.',
  clickToStartWork: 'Klicka nu på ruta 1 <strong>Mitt arbete</strong> så kör vi!',
  clickToStartSchool: 'Klicka nu på ruta 1 <strong>Min skolgång</strong> så kör vi!',
  denyMessage: 'Försöker du fuska va?<br/>Gör klart nivå 1 och 2 först!',
  angryMonsterAlt: 'Arg monster',
  myWork: 'Min skolgång',
  mySchool: 'Min skolgång',
  myLifestyle: 'Min livsstil',
  myGoals: 'Mina mål',
  myLifestylePlan: 'Min livsstilsplan'
};